import { PlayerCommand } from "../engine/playerCommand";

/**
 * Held keys in press order, so getActive() can return the most-recently-pressed key still
 * held: pressing a second direction steers to it, and releasing it falls back to the first.
 */
export class HeldKeyTracker {
	private stack: { key: string; cmd: PlayerCommand }[] = [];

	press(key: string, cmd: PlayerCommand): void {
		this.release(key);
		this.stack.push({ key, cmd });
	}

	release(key: string): void {
		const index = this.stack.findIndex((e) => e.key === key);
		if (index !== -1) this.stack.splice(index, 1);
	}

	clear(): void {
		this.stack.length = 0;
	}

	getActive(): PlayerCommand | null {
		return this.stack.length > 0 ? this.stack[this.stack.length - 1].cmd : null;
	}
}

/**
 * Held-repeat gate (delay-then-rate). A fresh tap must clear `initialDelayMs` — measured from the
 * keydown, not the last turn — before its first auto-repeat, so a quick press stays one turn even
 * when animations are sped up (the move animation no longer being the only thing pacing taps).
 * Once repeating, steps are throttled by `intervalMs`. Steering mid-hold keeps the original press
 * time (see the caller), so changing direction doesn't re-impose the delay.
 */
export function shouldRepeatHeldCommand(params: {
	heldCommand: PlayerCommand | null;
	vendingOpen: boolean;
	now: number;
	heldSince: number;
	lastTurnTime: number;
	initialDelayMs: number;
	intervalMs: number;
}): boolean {
	if (params.heldCommand === null || params.vendingOpen) return false;
	return (
		params.now - params.heldSince >= params.initialDelayMs && params.now - params.lastTurnTime >= params.intervalMs
	);
}
